const getImageFromSlot = ({
  element,
  slotRef
}) => {
  const imageSlot = element.querySelector(
    `[slot="${slotRef}"]`
  );
  const isImage = imageSlot instanceof HTMLImageElement;
  let image = imageSlot;
  if (isImage) {
    return image;
  }
  if (!isImage && imageSlot) {
    image = imageSlot.querySelector("img");
    return image;
  }
  return null;
};
export {
  getImageFromSlot
};
//# sourceMappingURL=getImageFromSlot.js.map
